import { useEffect } from 'react';
import { SITE_URL } from './site';

export interface SeoInput {
  title: string;
  description?: string;
  keywords?: string;
  canonicalPath?: string;
  image?: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string | undefined) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!content) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string | undefined) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function useSeo(input: SeoInput) {
  const { title, description, keywords, canonicalPath, image } = input;

  useEffect(() => {
    document.title = title;
    const canonical = canonicalPath ? `${SITE_URL}${canonicalPath}` : undefined;

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertCanonical(canonical);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:image', image);
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', image);
  }, [title, description, keywords, canonicalPath, image]);
}